<template>
  <div
    v-editable="blok"
    class="Wysiwyg layout-container"
    :class="desktopWidth('sm')"
  >
    <ReadMore
      v-if="blok.readMore"
      :show-in-storyblok="true"
      :max-height="readMoreHeight"
    >
      <div
        class="wysiwyg"
        :class="{
          'text-center': blok.centerText
        }"
      >
        <ExtendedWysiwyg :content="props.blok.content" />
      </div>
    </ReadMore>
    <div
      v-else
      class="wysiwyg"
      :class="{
        'text-center': blok.centerText
      }"
    >
      <ExtendedWysiwyg :content="props.blok.content" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { StoryBlokPropBase } from '~/constants/types/storyblok';
import useDesktopWidth from '~/composeables/useDesktopWidth';
import ExtendedWysiwyg from '~/components/globals/ExtendedWysiwyg.vue';
import { ISbRichtext } from 'storyblok-js-client';
import ReadMore from '~/components/generic/ReadMore.vue';

type Props = StoryBlokPropBase & {
  content: ISbRichtext,
  readMore: boolean,
  readMoreHeight: string,
  centerText?: boolean,
}

const props = defineProps<{
  blok: Props,
}>();

const { $toNumber } = useNuxtApp();
const readMoreHeight = computed(()=> {
  return props.blok.readMoreHeight ? $toNumber(props.blok.readMoreHeight) : 100;
});

const { desktopWidth } = useDesktopWidth(props);
</script>

<style scoped lang="postcss">

</style>
